<div *ngIf="feed_detail_api_in_process==true" class='text-center'>
       <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post">
   </div>

<div *ngIf="feedObject === undefined" class="my-3 heading-4">
    <div style="text-align:center" class="color-grey-500">{{error_msg}}</div>
</div>

   <div *ngIf="feedObject!=null && feedObject!=undefined"
    class="row m-0"
        [ngClass]="{'mb-5': fcs?.device_detail?.is_desktop!=true }">
        <div class="px-0 txt-sel media-container"
            *ngIf="feedObject?.media_list.length>0"
            [ngClass]="{'col-lg-12': fcs?.device_detail?.is_desktop!=true, 'col-lg-8': fcs?.device_detail?.is_desktop==true }">
            <div class="position-absolute w-100 pt-2 pb-2 pl-3 pr-3 bottom-media-like-comment-container"
                *ngIf="fcs?.device_detail?.is_desktop==true">
                <div class="row">
                    <div class="col-6">
                        <div class="new-modal-like-comment-icon border-0 pt-1 pb-1">
                            <div class="row">
                                <div class="like col-4">
                                    <span
                                        [dataTestId]="feedObject.product_type_id"
                                        [dataTestIdName]="dataTestId.FEED_DETAIL_LIKE_LEFT"
                                        class="cursor-pointer button"
                                        (click)="productLike()"
                                        >
                                        <!-- loader -->
                                        <img src="assets/themes/icons/primary-loader.gif"
                                            alt="loading"
                                            *ngIf="feed_like_loader==true" />
                                        <img src="assets/themes/icons/like-white-icon.svg"
                                            alt="like icon"
                                            *ngIf="feedObject?.like_status == 0 && feed_like_loader==false"
                                            width="19px" height="19px"/>

                                        <img src="assets/themes/icons/like-filled-white-icon.svg"
                                            alt="liked icon"
                                            *ngIf="feedObject?.like_status == 1 && feed_like_loader==false"
                                            width="19px" height="19px"/>
                                        <span *ngIf="feedObject?.like_status != 1" class="ml-2 text-white">{{mls?.languageText?.feed_detail?.key1}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key1)</span></span>
                                        <span *ngIf="feedObject?.like_status == 1" class="ml-2 text-white">{{mls?.languageText?.feed_detail?.key8}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key8)</span></span>
                                    </span>
                                </div>
                                <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="bookmark-modal col-4 pl-0 pr-0">
                                    <span
                                        [dataTestId]="feedObject.product_type_id"
                                        [dataTestIdName]="dataTestId.FEED_DETAIL_BOOKMARK_LEFT"
                                        class="cursor-pointer button"
                                        (click)="productBookmark()"
                                        >

                                        <img src="assets/themes/icons/primary-loader.gif"
                                            alt="loading"
                                            *ngIf="feed_bookmark_loader==true" />

                                        <img src="assets/themes/icons/bookmark-white-icon.svg"
                                            alt="bookmark icon"
                                            *ngIf="feedObject?.is_bookmarked==0 && feed_bookmark_loader==false"
                                            width="19px" height="19px"/>
                                        <img src="assets/themes/icons/bookmark-filled-white-icon.svg"
                                            alt="bookmarked icon"
                                            *ngIf="feedObject?.is_bookmarked==1 && feed_bookmark_loader==false"
                                            width="19px" height="19px"/>

                                        <span *ngIf="feedObject?.is_bookmarked!=1" class="ml-2 text-white">{{mls?.languageText?.feed_detail?.key2}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key2)</span></span>
                                        <span *ngIf="feedObject?.is_bookmarked==1" class="ml-2 text-white">{{mls?.languageText?.feed_detail?.key9}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key9)</span></span>
                                    </span>
                                </div>
                                <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="share-media col-4">
                                <span
                                    [dataTestId]="feedObject.product_type_id"
                                    [dataTestIdName]="dataTestId.FEED_DETAIL_SHARE_LEFT"
                                    class="post-edit-link position-relative">
                                    <span class="cursor-pointer button"
                                        (click)="productShare()"
                                        >
                                        <span class="text-white">
                                            <img src="assets/themes/icons/share-white-icon.svg" alt="Share icon" class="mr-2" />{{mls?.languageText?.feed_detail?.key3}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key3)</span>
                                        </span>
                                    </span>
                                </span>

                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="float-right">
                            <span
                                (click)="callLikeComponent('list');"
                                 *ngIf="feedObject?.total_like>0"
                                class="mr-3 cursor-pointer secondary-paragraph"><span class="color-light-grey">{{feedObject?.total_like}}

                                <span *ngIf="feedObject?.total_like==1">{{mls?.languageText?.feed_detail?.key1}}</span>
                                <span *ngIf="feedObject?.total_like>1">{{mls?.languageText?.feed_detail?.key11}}</span></span>
                            </span>
                            <span *ngIf="feedObject?.total_comments>0 && feedObject?.comment_flag!='0'"
                                class="secondary-paragraph"><span class="color-light-grey">{{feedObject?.total_comments}} <span *ngIf="feedObject?.total_comments==1">{{mls?.languageText?.feed_detail?.key6}}</span>
                                <span *ngIf="feedObject?.total_comments>1">{{mls?.languageText?.feed_detail?.key7}}</span></span>
                            </span>
                        </div>
                    </div>
               </div>
            </div>

            <div class="text-center feed-modal-video-container custom-mdb-carousel">
                <mdb-carousel id="mdbcr" [type]="'carousel-thumbnails'" tabindex="1" [activeSlideIndex]="mediaIdx" id="feed_modal_slider"  class="carousel slide carousel-fade h-100 thumbnail-image-radius" [animation]="'fade'"  [isControls]="true" [interval]="0"  [keyboard]="true" (activeSlideChange)="onActiveSlideChange($event)">
                    <mdb-carousel-item [ngClass]="{'h-100 w-100 d-flex':fcs?.device_detail?.is_desktop==true}"
                        *ngFor="let media of feedObject?.media_list; let idx=index"
                        [dataTestId]="feedObject.product_type_id +'-' + media.media_id"
                        [dataTestIdName]="dataTestId.FEED_DETAIL_MEDIA">
                        {{setslidercls()}}
                        <img class="d-none"
                            *ngIf="media?.media_type!='image' && media?.media_type!='audio'"
                            src="{{media?.media_thumbnail | fitInImg :igs.imageGroup.fitin_50x50}}"
                            onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />

                        <div class="w-100"
                            *ngIf="media?.media_type=='image'">
                            <img  [ngClass]="{'media-modal-cover-image':fcs?.device_detail?.is_desktop==true}"
                                src="{{media?.media_url | fitInImg :igs.imageGroup.fitin_1200x1200}}"
                                onerror="this.src='assets/themes/images/banner-placeholder-lg.svg';" >
                        </div>

                        <div *ngIf="media?.media_type=='document' && idx==mediaIdx"
                            [perfectScrollbar]="config"
                            class="ps position-relative w-100 document-view-container">

                            <app-pdf-view
                                [pdfscr]="media?.media_url"
                                [idx]="mediaIdx"
                                [useractivity]="useractivity"
                                [show_all_page]="true">
                            </app-pdf-view>
                        </div>

                        <div *ngIf="media?.media_type=='video'"
                            class="w-100 m-auto">
                            <app-shaka-basic
                                *ngIf="idx==mediaIdx"
                                [videoSrc]="media?.media_url"
                                [videoBanner]="media.media_thumbnail"
                                shakaStyleCss='shaka-model'
                                (emitPlayFlag)="playerEvent('video', true)"
                                (emitPauseFlag)="playerEvent('video', false)">
                            </app-shaka-basic>
                        </div>

                        <div *ngIf="media?.media_type=='youtube'">
                            <video class="modal_shadow control-container"
                                controls
                                name="media">
                                <source [src]="media?.media_url" >
                            </video>
                        </div>

                        <div *ngIf="media?.media_type=='audio'" class="pt-3 pb-3" [ngClass]="{'bg-audio': fcs?.device_detail?.is_mobile!=true}">
                            <img class="d-block d-lg-none mb-4 mx-auto"
                                width="100px" src="assets/images/grandround/audio.png"  />
                            <app-shaka-audio
                                *ngIf="idx===mediaIdx"
                                [videoSrc]="media?.media_url"
                                [pType]="productType"
                                (receiveSQSInterval)="receiveSQSInterval($event)">
                            </app-shaka-audio>
                        </div>
                    </mdb-carousel-item>
                </mdb-carousel>
            </div>
            <!-- media detail in carousal end-->
        </div>
        <div [ngClass]="{'col-lg-4 border-lg-left':feedObject?.media_list?.length>0 && fcs?.device_detail?.is_desktop==true,'col-12':feedObject?.media_list.length==0, 'col-lg-12': fcs?.device_detail?.is_desktop!=true}" class="pr-0 pl-0 right-panel-container bg-white">

        <div  class="clearfix new-modal-right-user-detail pt-3 pb-2 pt-md-5"
            [ngClass]="{'border-bottom': !postedIn}"
            [style.background-image]="isEditorsChoicePost && this.dss.ecProductFeed?.color | gradient: gradientDirection.BOTTOM">
            <!-- <app-audio-player  [audioSrc]="abc" [mediaIdx]="0"></app-audio-player> -->
            <span class="float-right cursor-pointer d-none d-lg-block" (click)="hideModal()">
                <img src="assets/themes/icons/cancel.svg" alt="Close icon" class="close-icon" />
            </span>

            <app-connection-card
                [callingfrom]="'feed detail'"
                [usercardsize]="'gr'"
                *ngIf="feedObject?.user_profile!=null"
                [suggObj]="feedObject?.user_profile"
                [is_anonymous]="feedObject?.is_anonymous"
                [isAuthor]="feedObject?.is_author"
                [calling_from]="'feed_detail'"
                [product]="feedObject"
                [posted_in]="postedIn"
                [isPostedEvent]="isPostedEvent"
                (emitOpenFeed)="handleOpenFeedEvent($event)"
                (emitCommunityDetail)="handleCommunityDetailEvent($event)">
            </app-connection-card>

            <app-channel-user-card
                *ngIf="feedObject?.channel!=null"
                [callingFrom]="'feed_detail'"
                [usercardsize]="'m'"
                [data]="feedObject?.channel"
                [productType]="productTypeConstant.FEED"
                [ecProductFeed]="dss.ecProductFeed">
            </app-channel-user-card>

            <!-- community user card -->
            <div *ngIf="feedObject?.hl?.n" class="d-flex justify-content-between connectionCard">
                <div class="pr-0 d-flex" (click)="redirectToCommunityDetail(feedObject?.hl?.code)">
                    <div class="float-left mr-2 profile-min-width cursor-pointer">
                        <div class="position-relative user-profile-pic-container">
                            <img class="rounded-circle box-size-40 post-pic"  [src]="feedObject?.hl?.l" onError="this.src='assets/themes/images/create-community-placeholder.svg';">
                        </div>
                    </div>
                    <div class="float-left pl-0 grandroundCardTextWidth cursor-pointer text-capitalize secondary-paragraph-bold">
                        {{feedObject?.hl?.n}}
                    </div>
                </div>
            </div>

        </div>
        <div id="product_detail_div_for_scroll"
            class="ps position-relative modal-comment-bg"
            [perfectScrollbar]="config"
            [ngClass]="{'modal-scroll':fcs?.device_detail?.is_desktop==true}">
            <div class="modal-body p-0">
            <div class="px-2 pt-2" *ngIf="!feedObject.channel && (showPostedIn || isPostedEvent)">
                <app-posted-in
                    [product]="feedObject"
                    [isPostedEvent]="isPostedEvent || showPostedIn">
                </app-posted-in>
            </div>
            <div class="py-2  bg-white">
                <div class="position-relative px-3 mb-2 product-modal-content">
                    <div class="mt-2 mb-2" *ngIf="feedObject?.title!='' && feedObject?.title!=undefined">
                        <div class="secondary-paragraph"
                            [innerHtml]="feedObject?.title | safehtml">
                        </div>
                    </div>

                    <div class="mb-2 paragraph">
                        <p
                            [dataTestId]="feedObject.product_type_id"
                            [dataTestIdName]="dataTestId.FEED_DETAIL_DESCRIPTION"
                            style="display:inline;"
                            *ngIf="feedObject?.content!=''"
                            class="userPostText color-grey-700 link-text"
                            innerHTML="{{ feedObject?.content | linkify}} ">
                        </p>
                    </div>
            <!-- meta url -->
                    <div *ngIf="feedObject?.meta_url!='' && feedObject?.meta_array!='' "
                        class="link-post mb-2 border bg-deep-green-100">
                        <a *ngIf="feedObject?.meta_array?.images!=false"
                            href="{{feedObject?.meta_array?.pageUrl}}"
                            target="_blank" class="singleimg-link">
                            <img  [src]="feedObject?.meta_array?.images"
                                onerror="this.src='assets/themes/icons/banner-placeholder.svg'">
                        </a>
                        <a href="{{feedObject?.meta_array?.pageUrl}}" target="_blank">
                        <div class="link-post-description p-2 cursor-pointer">
                            <h5 class="link-title secondary-paragraph mb-1">
                                <a class="paragraph-bold"
                                    href="{{feedObject?.meta_array?.pageUrl}}"
                                    target="_blank"
                                    innerHTML="{{feedObject?.meta_array?.title}}">
                                </a>
                            </h5>
                            <a href="{{feedObject?.meta_array?.pageUrl}}"
                                class="color-grey-700"
                                target="_blank">
                                <p class="primary-small color-grey-500 link-desc"
                                    innerHTML="{{ feedObject?.meta_array?.description }}">
                                </p>
                            </a>
                        </div>
                    </a>
                    </div>
                        <!--HTML CONTENT-->
                    <div *ngIf="feedObject?.html_content!='' && feedObject?.html_content!=undefined"
                        [innerHtml]="feedObject?.html_content | safehtml">
                    </div>

                    <div class="poll-post"
                        *ngIf="feedObject?.feed_kind=='poll' ">
                            <ul>
                                <!-- without selected -->
                                <li class="p-3 mb-3 cursor-pointer position-relative poll-item"
                                    *ngFor="let feedPoll of feedObject?.poll; let idx=index;" >
                                    <!-- without image-->
                                    <div class="position-relative"
                                        style="z-index: 1;"
                                        (click)="PollOnFeed(feedObject?.feed_id,feedPoll.option_id,feedObject?.poll_status,idx)" >
                                            <div class="row">
                                                <div *ngIf="feedPoll?.file_url==''"
                                                    [ngClass]="{'col-12':feedObject?.poll_status==0, 'col-8':feedObject?.poll_status==1 }">
                                                    <div
                                                        [ngClass]="{'secondary-paragraph':feedObject?.poll_status==1, 'secondary-paragraph':feedObject?.poll_status==0}"><span class="font-weight-600">{{feedPoll?.options}}</span><span *ngIf="feedPoll.mypoll==1" class="ml-3"><img width="24" height="24" src="assets/themes/icons/poll-tick-icon.svg"/></span>
                                                    </div>
                                                </div>
                                                <!-- with media -->
                                                <div *ngIf="feedPoll?.file_url!=''"
                                                    [ngClass]="{'col-12':feedObject?.poll_status==0, 'col-8':feedObject?.poll_status==1 }">
                                                        <div class="poll-option-img float-left mr-2 rounded-corners-12">
                                                            <img src={{feedPoll?.file_url}}
                                                                onerror="this.src='assets/themes/icons/banner-placeholder.svg'"/>
                                                    </div>

                                                    <div class="float-left pt-2 w-75">
                                                        <span [ngClass]="{'secondary-paragraph':feedObject?.poll_status==1, 'secondary-paragraph':feedObject?.poll_status==0}"><span class="font-weight-600">{{feedPoll?.options}}</span><span
                                                        *ngIf="feedPoll?.mypoll==1"><img width="24" height="24" class="ml-2"
                                                            src="assets/themes/icons/poll-tick-icon.svg" /></span></span>
                                                    </div>
                                                </div>
                                            <div class="col-4 text-right" [ngClass]="{'d-none':feedObject?.poll_status==0, 'pt-2':feedPoll?.file_url!='' }"><span class="secondary-paragraph-bold">{{feedPoll.per}}%</span></div>

                                                    </div>
                                    </div>
                                <!-- percentage bar -->
                                <div class="h-100"
                                    [ngClass]="{'percentage-bar': feedPoll?.per !== '0.00' }"
                                    [ngStyle]="getMyStyles(feedPoll.per,feedObject?.poll_status)"></div>
                                </li>
                            </ul>
                    </div>
                    <!-- end new poll  -->
                    <div class="post-tags mt-2 mb-2 secondary-paragraph"
                        *ngIf="feedObject?.speciality?.length>0" >
                        <!-- (click)="filterBySpeciality(Sl)" -->
                        <span (click)="getSpecialty({speciality: Sl, modalAction: 'close-modal'}, true)"
                            *ngFor="let Sl of feedObject?.speciality;"
                            class="mr-2 cursor-pointer color-grey-500">
                            <b [dataTestId]="feedObject.product_type_id + '-' + Sl?.speciality_id" [dataTestIdName]="dataTestId.FEED_DETAIL_SPECIALITY">#{{ Sl?.speciality_name }}</b>
                        </span>
                    </div>
                    <div class="post-tags mt-2 mb-2 secondary-paragraph"
                        *ngIf="feedObject?.user_tagged.length>0">
                        <p class="secondary-paragraph-bold border-top pt-2"><span class="color-grey-500">{{mls?.languageText?.feed_detail?.key12}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key12)</span></span></p>
                        <span *ngFor=" let Tl of feedObject?.user_tagged" class="mr-2 color-blue">
                            <b [dataTestId]="Tl.custom_id" [dataTestIdName]="dataTestId.FEED_DETAIL_TAG_USER" (click)="gototaggeduser(Tl)" class="cursor-pointer">@{{Tl?.full_name}}</b></span>
                    </div>

                    <!-- <h5 *ngIf="feedObject?.title!=''" class="title_Case fnt-size14px fnt-weight500">{{ feedObject?.title }}</h5>   -->
                </div>

                <div class="postbox mb-2 px-3 secondary-paragraph rounded repost_disabled"
                    *ngIf="feedObject.repost_content !== null && feedObject.repost_content.product_type === productTypeConstant.FEED">
                    <app-feed-card
                      appear
                      [callingfrom]="createRepostScreen"
                      [feedObj]="feedObject.repost_content.data"
                      [source]="numbers.ONE"
                      [ptoductType]="numbers.ONE"
                      [feedIdx]="numbers.ONE"
                      [textHeighlight]=""
                      [flags]="numbers.ONE"
                      (feedSpecialty)="getSpecialty($event)">
                    </app-feed-card>
                </div>

                <div *ngIf="feedObject.repost_info?.is_available === numbers.ZERO"
                    class="postbox mb-2 rounded repost_disabled p-3 deleted-info">
                    <p class="secondary-paragraph font-weight-600 pb-2 ">{{feedObject.repost_info?.message?.title}}</p>
                    <p class="primary-small font-weight-500">{{feedObject.repost_info?.message?.description}}</p>
                </div>

                <div class="p-2 border px-3 rounded"
                  *ngIf="feedObject.repost_content != null && feedObject.repost_content.product_type === productTypeConstant.WEBINAR">
                    <app-webinar-card
                        [callingfrom]="feedDetailScreen"
                        [docCardObj]="feedObject.repost_content.data"
                        [docTalkSection]=""
                        [listLength]="1">
                    </app-webinar-card>
                </div>

                <div class="p-2 border rounded"
                  *ngIf="feedObject.repost_content !== null && feedObject?.repost_content?.product_type === productTypeConstant.DOCTALKS">
                <app-web-doctalk-card
                  appear
                  [callingfrom]="feedDetailScreen"
                  [docCardObj]='feedObject.repost_content.data'
                  [docTalkSection]='"features_videos"'
                  [listLength]=2>
                </app-web-doctalk-card>
            </div>


            <div class="p-2 border rounded"
                *ngIf="feedObject.repost_content !== null && feedObject?.repost_content?.product_type === productTypeConstant.ARTICLE">
                <app-clinical-resource-card
                appear
                [callingfrom]="feedDetailScreen"
                [clinicalObj]="feedObject.repost_content.data"
                [idx]="0">
              </app-clinical-resource-card>
            </div>



                <div class="new-modal-like-comment-count px-3">
                    <p class="clearfix">
                        <span class="float-left secondary-paragraph" *ngIf="feedObject?.total_like==0"><span class="color-black-400">{{mls?.languageText?.feed_detail?.key5}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key5)</span></span></span>

                        <span (click)="callLikeComponent('list');"
                            *ngIf="feedObject?.total_like>0"
                            class="float-left secondary-paragraph cursor-pointer"><span class="color-black-400">{{feedObject?.total_like}} <span *ngIf="feedObject?.total_like==1">{{mls?.languageText?.feed_detail?.key1}}</span>
                        <span *ngIf="feedObject?.total_like>1">{{mls?.languageText?.feed_detail?.key11}}</span> </span></span>

                    <span *ngIf="feedObject?.total_comments>0 && feedObject?.comment_flag!='0'" class="float-right secondary-paragraph cursor-pointer"><span class="color-black-400">{{feedObject?.total_comments}} <span *ngIf="feedObject?.total_comments==1">{{mls?.languageText?.feed_detail?.key6}}</span>
                    <span *ngIf="feedObject?.total_comments>1">{{mls?.languageText?.feed_detail?.key7}}</span></span></span></p>
                </div>

                <div class="like-comment-icon py-3 px-md-3">
                    <div class="row">
                        <div class="like col-3">
                            <span [dataTestId]="feedObject.product_type_id" [dataTestIdName]="dataTestId.FEED_DETAIL_LIKE_RIGHT" class="position-relative">
                                <app-custom-tooltip *ngIf="tooltip_data?.length>0" [tooltip_data]="tooltip_data" [view_identifier]="'FEED_LIKE'" [position]="'bottom-left'"></app-custom-tooltip>

                        <span (click)="productLike()"
                             class="cursor-pointer button d-flex justify-content-center alignment">
                            <img src="assets/themes/icons/primary-loader.gif"
                                alt="loading"
                                width="20px"
                                height="20px"
                                *ngIf="feed_like_loader==true" />

                            <img src="assets/themes/icons/like-white.svg"
                                alt="like icon"
                                *ngIf="feedObject?.like_status == 0 && feed_like_loader==false"
                                />
                            <img src="assets/themes/icons/like-black.svg"
                                alt="liked icon"
                                *ngIf="feedObject?.like_status == 1 && feed_like_loader==false"
                                />

                            <span *ngIf="feedObject?.like_status != 1" class="left-margin color-grey-700">{{mls?.languageText?.feed_detail?.key1}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key1)</span></span>
                            <span *ngIf="feedObject?.like_status == 1" class="left-margin color-grey-700">{{mls?.languageText?.feed_detail?.key8}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key8)</span></span></span>
                        </span>
                        </div>
                        <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="bookmark-modal col-3 px-0">
                            <span [dataTestId]="feedObject.product_type_id"
                                [dataTestIdName]="dataTestId.FEED_DETAIL_BOOKMARK_RIGHT"
                                (click)="productBookmark()"
                                
                                class="cursor-pointer button d-flex justify-content-center alignment">
                                <!-- loader -->
                                <img src="assets/themes/icons/primary-loader.gif"
                                    alt="loading"
                                    width="19px"

                                    *ngIf="feed_bookmark_loader==true" />
                                <img src="assets/themes/icons/bookmark-white.svg"
                                    alt="bookmark icon"
                                    width="16"
                                    *ngIf="feedObject?.is_bookmarked==0 && feed_bookmark_loader==false"
                                    />

                                <img src="assets/themes/icons/bookmark-black.svg"
                                    alt="bookmarked icon"

                                    *ngIf="feedObject?.is_bookmarked==1 && feed_bookmark_loader==false"
                                    />

                            <span *ngIf="feedObject?.is_bookmarked!=1" class="left-margin color-grey-700">{{mls?.languageText?.feed_detail?.key2}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key2)</span></span>
                            <span *ngIf="feedObject?.is_bookmarked==1" class="left-margin color-grey-700">{{mls?.languageText?.feed_detail?.key9}}<span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key9)</span></span></span>
                        </div>
                        <div *ngIf="this.mls.featureOnOffList.featureList.repost.value || !mls.userLoginFlow" class="bookmark-modal col-3 pl-3 pr-0">
                            <span class="cursor-pointer button color-grey-700 alignment" [callingFrom]="'FEED_POSTING'" (click)="$event.stopPropagation();generateMeta()">
                                <img class="repost_icon_width" src="assets/themes/icons/repost.svg" alt="icon-repost" >
                                {{mls?.languageText?.feed_detail?.key14}}
                                <app-repost-type-list-meta *ngIf="isMetaGenerated" [productId]="feedObject.product_type_id" (closeToolTip)="closeMeta($event)" (emitRepostType)="repostFeed($event)"></app-repost-type-list-meta>
                            </span>
                        </div>
                        <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="share col-3 px-0">
                            <span [dataTestId]="feedObject.product_type_id"
                                [dataTestIdName]="dataTestId.FEED_DETAIL_SHARE_RIGHT"
                                class="post-edit-link position-relative ">
                                <app-custom-tooltip *ngIf="tooltip_data?.length>0" [tooltip_data]="tooltip_data" [view_identifier]="'FEED_SHARE'" [position]="'top-right'"></app-custom-tooltip>

                                <span (click)="productShare()"
                                    
                                    class="cursor-pointer button d-flex justify-content-center">
                                    <span class="alignment" ><img src="assets/themes/icons/share.svg" width="22" alt="Share icon" /> <span class="left-margin">{{mls?.languageText?.feed_detail?.key3}}</span><span *ngIf="mls?.is_lskey_display==1">(feed_detail?.key3)</span></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- comment -->
                <div *ngIf="feedObject?.comment_flag==1">
                    <div class="text-center" id="feed-detail-tagcomment">
                        <div class="p-2" *ngIf="feedObject?.total_comments==''">
                            <img width="180px" src="assets/themes/icons/no-chat.svg" alt="no-comment" />
                            <p class="heading-4 text-center"><span class="color-grey-500">{{mls.languageText.comment_card.key12}}<span *ngIf="mls?.is_lskey_display==1">(comment_card.key12)</span></span></p>
                        </div>
                        <app-product-comment
                            [callingFrom]="feedDetailScreen"
                            (emitComment)="emitComment($event)"
                            (shareCommentCountToParent)="shareCommentCountToParent($event)"
                            (resetCmtList)="resetCmtList($event)"
                            [commentObj]=commentObj
                            [showCommentBox]="0"
                            [comment_box_obj]="comment_box_obj"
                            [list_type]="commentListType.TOP">
                        </app-product-comment>
                    </div>
                </div>
            </div>

            </div>
            <div [ngClass]="{'pt-2 pb-2': fcs?.device_detail?.is_desktop!=true, 'p-2 modal-comment-bg': fcs?.device_detail?.is_desktop==true }">
                <app-common-suggestion *
                    ngIf='suggestionObj !=undefined'
                    [suggestionObj]="suggestionObj">
                </app-common-suggestion>
            </div>

                <!-- end -->
        </div>
        <div class="p-2 border-top bg-white bottom-comment-container" *ngIf="feedObject?.comment_flag==1" [ngClass]="{'fixed-bottom': fcs?.device_detail?.is_desktop!=true}">
            <app-custom-tooltip *ngIf="tooltip_data?.length>0" [tooltip_data]="tooltip_data" [view_identifier]="'FEED_COMMENT'" [position]="'top'"></app-custom-tooltip>
            <app-product-comment-box
                [callingFrom]="feedDetailScreen"
                *ngIf="feedObject?.comment_flag==1"
                [comment_box_obj]="comment_box_obj"
                (resetComment)="resetComment($event)"
                [emitUserComment]="emitUserComment">
            </app-product-comment-box>
        </div>
        </div>
   </div>

   <!-- like list popup start**************************** -->
   <app-product-like
    *ngIf="showLikeListModal==true"
    (resetLikeModalList)="resetLikeModalList($event) "
    (resetLike)="resetLike($event) "
    [likeObj]="likeObj">
    </app-product-like>
   <!-- like list popup end ***************************** -->

   <!-- Bookmark start -->
   <app-product-bookmark
    *ngIf="is_bookmark==true"
    (resetBookmark)="resetBookmark($event)"
    [bookmarkObj]="bookmarkObj">
    </app-product-bookmark>
   <!-- Bookmark end -->